import axios, { AxiosResponse } from "axios";
import {
	QueueLogLevelChangeRequest,
	ServiceLogLevelResponse,
	UpdateServiceLogLevelResponseObject,
} from "../../models/Administration";

/**
 * API Service for calling into POW to retrieve all service log levels
 */
export const getAllServiceLogLevels = () => async (): Promise<AxiosResponse<ServiceLogLevelResponse[]>> => {
	return await axios.get(`/api/v1/serviceLogLevel`);
};

/**
 * API service for calling into POW to update service log levels
 * @param requests The requests being sent to PDP to attempt changing a services queues
 */
export const updateServiceLogLevels =
	(requests: QueueLogLevelChangeRequest[]) => async (): Promise<AxiosResponse<UpdateServiceLogLevelResponseObject>> => {
		return await axios.post(`/api/v1/serviceLogLevel`, requests);
	};
